import { useState, useCallback } from 'react';
import { FormModeEnum } from '@project-types/FormModeEnum';
import OrderForm from '@pages/order/OrderForm';
import OrderSummary from '@pages/order/OrderSummary';



const Order = () => {

	const [ formMode, setFormMode ] = useState<FormModeEnum>(FormModeEnum.form);

	
	const goToSummary = useCallback(() => {
		setFormMode(FormModeEnum.summary);
	},[]);


	const goToForm = useCallback(() => {
		setFormMode(FormModeEnum.form);
	},[]);

	
	return (
		<div className="app-page order-page">

			{formMode === FormModeEnum.form &&
				<OrderForm goToSummary={goToSummary} />}
			
			{formMode === FormModeEnum.summary &&
				<OrderSummary goToForm={goToForm} />}

		</div>
	);
};

export default Order;